import React from 'react'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'
import { useLocation } from 'react-router-dom'
import { Services } from '../../../services'
import { BttPix, Loading } from '../../Simple'
import RouterHook from '../../../contexts/RouterHook'
import { IoIosArrowBack } from 'react-icons/io'
import { BiCalendarX } from 'react-icons/bi'
import CancelarDiaria from '../../Modais/CancelarDiaria/CancelarDiaria'
import useDetalhesDiaria from './Diaria.functions.ts'
import { CompError } from '../../Complex/index.js'
import { Box } from '@mui/material'

import './stylesD.css'

export default function DiariaDesk() {
  const serverRouter = RouterHook()
  const location = useLocation()
  const { sttCtxAgend, modaisAgend, loadAgend, actionsDiaria } =
    React.useContext(AgendamentoContext)
  const { verificarAcessoUsuario, BuscarDiariaId, semAcesso } = useDetalhesDiaria()

  React.useEffect(() => {
    const idcompraDayuse = location.pathname.split('/').pop()

    BuscarDiariaId(idcompraDayuse).then(diaria => {
      verificarAcessoUsuario(diaria)
    })
  }, [])

  function RetornaPayState(diaria) {
    if (diaria.status !== 'CANCELADA') {
      if (diaria.valorTotal === diaria.valorRealizado)
        return <h4 style={{ color: '#8FBC8F' }}>PAGO</h4>
      else return <h4 style={{ color: 'red' }}>PENDENTE</h4>
    } else {
      return <h4 style={{ color: '#bf3324   ' }}>CANCELADO</h4>
    }
  }

  function FormaPay(status) {
    switch (status) {
      case 'CARTAO_CREDITO':
        return 'CARTÃO DE CRÉDITO'
      default:
        return status
    }
  }

  function StartGoPix() {
    serverRouter('pix', sttCtxAgend.diariaSel.pagamento.idExternoPagamento)
  }

  //console.log('sttCtxAgend.diariaSel', sttCtxAgend)

  return (
    <>
      {modaisAgend.cancelamentoDiaria && (
        <CancelarDiaria
          show={modaisAgend.cancelamentoDiaria}
          onClose={() => actionsDiaria.handleModaisAgend('cancelamentoDiaria', false)}
        />
      )}

      {loadAgend.diaria ? (
        <div className='contain-loading'>
          <Loading text={'Carregando diária...'} color='white' />
        </div>
      ) : semAcesso ? (
        <CompError
          title='Diária não encontrada'
          message='A diária que você está tentando acessar não foi encontrada.'
        />
      ) : (
        <>
          <div className='contain-agenda-page'>
            <IoIosArrowBack
              className='btt-back-agenda'
              onClick={() => {
                serverRouter('back')
              }}
            />
            <h2 className='title-page-diaria'>
              {' '}
              {`Diaria #${location.pathname.split('/').pop()}`}
            </h2>
            <div className='contain-view-diaria'>
              <div className='contain-detalhes-diaria'>
                <div className='contain-view-diaria-sel'>
                  <div className='contain-view-status-diaria'>
                    <h2 className='text-diaria-infos-du'>
                      Solicitada em:{' '}
                      <a style={{ color: '#DA5A34' }}>{`${Services.DataFormat(
                        'dia,DD/MM/YY',
                        sttCtxAgend.diariaSel.createdAt,
                      )} às ${Services.ReturnHoraMin(new Date(sttCtxAgend.diariaSel.createdAt))}, por ${sttCtxAgend.diariaSel.usuario.nome}`}</a>
                    </h2>
                    {sttCtxAgend.diariaSel.dataAprovacao !== null && (
                      <h2 className='text-diaria-infos-du'>
                        Aprovada em:{' '}
                        <a style={{ color: '#DA5A34' }}>{`${Services.DataFormat(
                          'dia,DD/MM/YY',
                          sttCtxAgend.diariaSel.dataAprovacao,
                        )} às ${Services.ReturnHoraMin(new Date(sttCtxAgend.diariaSel.dataAprovacao))}, por: ${
                          sttCtxAgend.diariaSel.aprovadoPor
                        }`}</a>
                      </h2>
                    )}
                    {sttCtxAgend.diariaSel.dataCancelamento !== null &&
                      sttCtxAgend.diariaSel.canceladoPor !== null && (
                        <>
                          <h2 className='text-diaria-infos-du'>
                            Cancelada em:{' '}
                            <a style={{ color: '#DA5A34' }}>{`${Services.DataFormat(
                              'dia,DD/MM/YY',
                              sttCtxAgend.diariaSel.dataCancelamento,
                            )} às ${Services.ReturnHoraMin(new Date(sttCtxAgend.diariaSel.dataCancelamento))}, por: ${
                              sttCtxAgend.diariaSel.canceladoPor
                            }`}</a>
                          </h2>
                          {sttCtxAgend.diariaSel.motivoCancelamento !== null &&
                            sttCtxAgend.diariaSel.motivoCancelamento !== '' && (
                              <h2 className='text-diaria-infos-du'>
                                Motivo do cancelamento:{' '}
                                <a
                                  style={{ color: '#DA5A34' }}
                                >{`${sttCtxAgend.diariaSel.motivoCancelamento}`}</a>
                              </h2>
                            )}
                        </>
                      )}
                  </div>
                  <div className='line-border-bottom' />
                  <div className='contain-modal-status-pays'>
                    <div className='contain-modal-status-pays-line'>
                      <h3 className='title-pagamentos-modal-view'>Pagamento</h3>
                      {RetornaPayState(sttCtxAgend.diariaSel)}
                    </div>
                    {
                      <div className='contain-modal-status-pays-line'>
                        <h3 className='modal-txt-infos-valores'>Forma de Pagamento</h3>
                        <h3 className='modal-txt-valores color-contratado'>
                          {FormaPay(sttCtxAgend.diariaSel.formaPagamento)}
                        </h3>
                      </div>
                    }
                    <div className='contain-modal-status-pays-line'>
                      <h3 className='modal-txt-infos-valores'>Valor Total</h3>
                      <h3 className='modal-txt-valores color-contratado'>
                        {`R$${sttCtxAgend.diariaSel.valorTotal.toFixed(2).toString().replace('.', ',')}`}
                      </h3>
                    </div>
                    {sttCtxAgend.diariaSel.valorPendente !== 0 &&
                      sttCtxAgend.diariaSel.valorPendente !== null &&
                      sttCtxAgend.diariaSel.status !== 'CANCELADA' && (
                        <div className='contain-modal-status-pays-line'>
                          <h3 className='modal-txt-infos-valores'>Valor Pendente</h3>
                          <h3 className='modal-txt-valores color-restante'>
                            {`R$${sttCtxAgend.diariaSel.valorPendente.toFixed(2).toString().replace('.', ',')}`}
                          </h3>
                        </div>
                      )}
                    {sttCtxAgend.diariaSel.valorRealizado !== 0 &&
                      sttCtxAgend.diariaSel.valorRealizado !== null &&
                      sttCtxAgend.diariaSel.status !== 'CANCELADA' && (
                        <div className='contain-modal-status-pays-line'>
                          <h3 className='modal-txt-infos-valores'>Valor Pago</h3>
                          <h3 className='modal-txt-valores color-pago'>
                            {`R$${sttCtxAgend.diariaSel.valorRealizado.toFixed(2).toString().replace('.', ',')}`}
                          </h3>
                        </div>
                      )}
                    {sttCtxAgend.diariaSel.valorEstornado > 0 &&
                      sttCtxAgend.diariaSel.status === 'CANCELADA' && (
                        <div className='contain-modal-status-pays-line'>
                          <h3 className='modal-txt-infos-valores'>Valor Estornado</h3>
                          <h3 className='modal-txt-valores color-cancelado'>
                            {`R$${sttCtxAgend.diariaSel.valorEstornado.toFixed(2).toString().replace('.', ',')}`}
                          </h3>
                        </div>
                      )}
                    {sttCtxAgend.diariaSel.status === 'SOLICITADA' &&
                    sttCtxAgend.diariaSel.formaPagamento === 'PIX' ? (
                      <BttPix
                        onClick={() => {
                          StartGoPix()
                        }}
                        text={'Ver código PIX'}
                      />
                    ) : (
                      <></>
                    )}
                    {sttCtxAgend.diariaSel.status === 'AGENDADA' && (
                      <button
                        className='btt-cancelar-day-use'
                        onClick={() => {
                          actionsDiaria.handleModaisAgend('cancelamentoDiaria', true)
                        }}
                      >
                        <h2>Cancelar Diária</h2>
                        <BiCalendarX size={30} color='white' />
                      </button>
                    )}
                  </div>
                  <div className='contain-modal-diaria-infer'>
                    <img
                      src={`${sttCtxAgend.diariaSel.dayuse.empresa.urlFoto}${sttCtxAgend.diariaSel.dayuse.empresa.foto}`}
                      alt='Foto da empresa'
                      onError={() => {}}
                    />
                    <h3 className='text-diaria-status-pay'>
                      {sttCtxAgend.diariaSel.dayuse.empresa.nome}
                    </h3>
                  </div>
                </div>
              </div>
              <div className='contain-diaria-selected'>
                <div className='contain-diaria-static'>
                  <div className='contain-diaria-superior border-botton-diaria-2'>
                    <div className='contain-diaria-interior'>
                      <h2>{sttCtxAgend.diariaSel.dayuse.titulo}</h2>
                      <h3 className='rotulo-h3-novo-padrao'>{`R$${sttCtxAgend.diariaSel.dayuse.valor.toFixed(2).toString().replace('.', ',')}`}</h3>
                    </div>
                    <h3 className='rotul-diaria-data-2'>{`${Services.ReturnDiaSemana(3, new Date(sttCtxAgend.diariaSel.data))}`}</h3>
                  </div>
                  <div className='contain-diaria-inferior'>
                    <h2>REGRAS DA DIÁRIA</h2>
                    <h3>
                      Forma de pagamento:{' '}
                      {sttCtxAgend.diariaSel.dayuse.formaPagamento.includes('PIX') &&
                      sttCtxAgend.diariaSel.dayuse.formaPagamento.includes('CARTAO_CREDITO')
                        ? 'Pix ou Cartão de crédito'
                        : sttCtxAgend.diariaSel.dayuse.formaPagamento.includes('PIX')
                          ? 'Pix'
                          : 'Cartão de crédito'}
                    </h3>
                    <h3>Duração: {sttCtxAgend.diariaSel.dayuse.duracao}</h3>
                    <h3>
                      Cancelamento:{' '}
                      {sttCtxAgend.diariaSel.dayuse.usuarioPodeCancelar === 'DIA'
                        ? 'Até o dia anterior'
                        : sttCtxAgend.diariaSel.dayuse.usuarioPodeCancelar === 'SEMPRE'
                          ? 'Você pode cancelar a qualquer momento'
                          : 'Não poderá cancelar'}
                    </h3>
                    <h3>Valida para: {sttCtxAgend.diariaSel.dayuse.quadra}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Box sx={{ height: '100%', alignContent: 'center', pb: 2 }}>
            <div
              className='rtz-banner'
              data-rtz-espaco-id='120'
              style={{ width: '728px', height: '90px', overflow: 'hidden' }}
              data-rtz-width='728'
              data-rtz-height='90'
              title='Espaço publicitário'
              data-rtz-display-formato='imagem_video'
              data-rtz-tipo-criativo='360'
              data-rtz-device='desktop'
            ></div>
          </Box>
        </>
      )}
    </>
  )
}
